/* Per-path intro video configuration.
 * Approved 2026-02 · titles verified via YouTube oEmbed (uploader: learnixta).
 * Swap videoId here to change any intro without touching component code.
 *
 * Inner Specializations is intentionally NOT listed here — its video stays
 * wired directly inside SpecIntroVideo.jsx (unchanged legacy defaults). */
export const INTRO_VIDEOS = {
  after_10th_inter: { videoId: 'Z90hLOTpiDg', eyebrow: 'Career Clarity Tests' },
  job_roles:        { videoId: 'xag-7H1z8e0', eyebrow: 'Future-Ready Job Roles' },
  ai_pathway:       { videoId: 'Y7n7__OBoYs', eyebrow: 'Future AI Agent Pathway' },
  banking:          { videoId: 'NqV7M3Zf2Vw', eyebrow: 'Banking Careers' },
  blue_collar:      { videoId: 'cjPsYW9XSBs', eyebrow: 'Blue-Collar Jobs' },
  build_badges:     { videoId: 'qskbVobNRLM', eyebrow: 'Build Badges' },
  ai_risk_check:    { videoId: 'YKOUVaPaxV4', eyebrow: 'Is AI Coming for Your Role' },
  ownpath:          { videoId: 'pKgoRriLJ0Q', eyebrow: 'Entrepreneurship · OwnPath' },
};

export const getIntroVideo = (pathKey) => INTRO_VIDEOS[pathKey] || null;
